import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";
export default class ShopProductApi {
  static uri = "a/internet/shopProduct";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: string) {
    return getData({
      uri: ShopProductApi.uri,
      id,
      context: this.context,
    });
  }
}
